const data = (collection, keyword, filterType, filterStatus, filterDateStart, filterDateEnd) => (
  collection
    && Object.values(collection).filter((item) => {
      let available = false;
      if (
        (
          item.attributes.number
            .toLowerCase()
            .includes(keyword.toLowerCase())
          || item.attributes.coach_name
            .toLowerCase()
            .includes(keyword.toLowerCase())
          || item.attributes.members
            .toLowerCase()
            .includes(keyword.toLowerCase())
        )
        && item.attributes.invoice_type.includes(filterType ? filterType.value : '')
        && (
          filterStatus === null
          || (filterStatus.value === item.attributes.status)
        )
        && (
          filterDateStart === null || filterDateStart === ''
          || (filterDateStart.unix() <= item.attributes.created_at_int)
        )
        && (
          filterDateEnd === null || filterDateEnd === ''
          || (filterDateEnd.endOf('day').unix() >= item.attributes.created_at_int)
        )
      ) { available = true; }

      return available;
    })
);

// created_at_int

export default data;
